/* SlouchFix: subtle scroll reveals. Vanilla, deferred, no dependencies.
   Only below-the-fold elements are ever hidden, and only by this script, so content stays visible without JS. */
(function () {
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SEL = '.sf-head,.sf-why__card,.sf-step,.sf-review,.sf-usp__item,.sf-results__media,.sf-results__content,.sf-steps__media,.sf-gallery__track,.sf-bonus__media,.sf-bonus__content,.sf-acc,.sf-spot__media,.sf-spot__content,.sf-cta .sf-wrap,.sf-track__card,.sf-faq .sf-head';
  var vh = window.innerHeight || 800;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target, d = parseInt(el.style.getPropertyValue('--sf-d'), 10) || 0;
      el.classList.add('sf-in'); io.unobserve(el);
      setTimeout(function () { el.classList.remove('sf-reveal', 'sf-in'); el.style.removeProperty('--sf-d'); }, 560 + d); /* hand back to normal hover transitions */
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
  document.querySelectorAll(SEL).forEach(function (el) {
    if (el.closest('.sf-sticky,.product-information,#SfSticky')) return;
    for (var a = el.parentElement; a && a !== document.body; a = a.parentElement) { var ox = getComputedStyle(a).overflowX; if (ox === 'auto' || ox === 'scroll') return; } /* never hide items inside horizontal scrollers */
    var r = el.getBoundingClientRect();
    if (r.top < vh && r.bottom > 0) return; /* already on screen: never hide */
    var sibs = Array.prototype.filter.call(el.parentElement.children, function (c) { return c.matches(SEL); });
    el.style.setProperty('--sf-d', Math.min(sibs.indexOf(el), 5) * 70 + 'ms');
    el.classList.add('sf-reveal');
    io.observe(el);
  });
})();
